<template>
  <div class="card mt-2">
    <div class="card-header">
      <i class="fa fa-address-book-o"></i> Novo
      Ssv 2300 Confi Opeda Ws
    </div>

    <b-form ref="form" @submit.prevent="onSubmit" @reset="onReset">

      <ssv2300-confi-opeda-ws-form :ssv2300ConfiOpedaWs="ssv2300ConfiOpedaWs" :violations="violations"></ssv2300-confi-opeda-ws-form>

      <div class="row">
        <div class="form-group col-sm-12 mb-2 mr-1 text-right">
          <button class="btn-sm btn btn-sm btn-outline-success mr-1" type="submit" data-toggle="tooltip" data-placement="bottom" title="Salvar">
            <i class="fa fa-floppy-o"></i> Salvar
          </button>

          <button class="btn btn-sm btn-outline-danger mr-1" type="button" data-toggle="tooltip" data-placement="bottom" title="Limpar" @click="onReset()">
            <i class="fa fa-eraser"></i> Limpar
          </button>

          <button class="btn btn-sm btn-outline-dark mr-1" type="button" data-toggle="tooltip" data-placement="bottom" @click="$router.go(-1)" title="Voltar">
            <i class="fa fa-arrow-left"></i> Voltar
          </button>
        </div>
      </div>
    </b-form>
  </div>
</template>

<script>
  import {
    mapGetters
  } from "vuex";
  
  import store from "@/store";
  
  import {  
    CREATE_SSV2300_CONFI_OPEDA_WS,  
    RESET_SSV2300_CONFI_OPEDA_WS
  } from "@/store/actions.type";
  
  import Ssv2300ConfiOpedaWsForm from '@/components/Ssv2300ConfiOpedaWsForm';
  
  export default {
    components: {
      Ssv2300ConfiOpedaWsForm
    },
  
    data() {
      return {
  	 violations: {},
       responseMessage: null,
       successORError: null,
      };
    },
  
    computed: {
      ...mapGetters(['ssv2300ConfiOpedaWs'])
    },
  
    methods: {
      onSubmit() {
        this.violations = {};
        return this.$store.dispatch(CREATE_SSV2300_CONFI_OPEDA_WS)
          .then(ssv2300ConfiOpedaWs => {
          	 this.flash().destroyAll();
               this.flashSuccess("Registro criado com sucesso.");
               this.$router.push({
                   name: 'ssv2300-confi-opeda-ws-edit',
                   params: { id: ssv2300ConfiOpedaWs.cdOpeda }
               });
              store.dispatch(RESET_SSV2300_CONFI_OPEDA_WS);
          })
          .catch(response => {
            this.flash().destroyAll();
            this.flashError("Ocorreu um erro ao tentar realizar cadastro.");
            if (response.body.violations) this.violations = response.body.violations;
            throw response.body.message;
          });
      },
      onReset() {
        this.violations = {};
        store.dispatch(RESET_SSV2300_CONFI_OPEDA_WS);
      }
    },
  
    async beforeRouteEnter(to, from, next) {
      await store.dispatch(RESET_SSV2300_CONFI_OPEDA_WS);
      return next();
    }
  };
</script>